import { APP_CONFIG } from '@/lib/app/config';

export const publicWebURLs = {
  appStore: APP_CONFIG.appStoreURL,
  browse: '/events',
  download: APP_CONFIG.downloadURL,
  playStore: APP_CONFIG.playStoreURL,
  supportEmail: `mailto:${APP_CONFIG.supportEmail}`,
} as const;
